import { BusDoorIcon, FridgeIcon, SeatIcon, ToiletIcon } from '@/assets/icons/bus/_';
import { BusEntityType } from '@/constants';
import React from 'react';
import { Form, Input, Popover, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { CreateUpdateSeatingModelDetailModel, CompanyTicketClassDto } from '@/__generated';

type Props = {
  seat: CreateUpdateSeatingModelDetailModel;
  ticketClasses: CompanyTicketClassDto[];
};

export default function SeatDetail({ seat, ticketClasses }: Props) {
  const { t } = useTranslation();
  const [showDetail, toggleDetail] = React.useState<boolean>(false);

  const ticketClassOptions = React.useMemo(() => {
    return ticketClasses.map(d => ({ value: d.ticketClassId, label: d.name }));
  }, [ticketClasses]);

  const color = React.useMemo(() => {
    return ticketClasses.find(x => x.ticketClassId === seat.baseTicketClassId)?.seatColor;
  }, [seat, ticketClasses]);

  if (seat.busEntityType === BusEntityType.Door) {
    return (
      <div className="seat-detail">
        <BusDoorIcon />
      </div>
    );
  }
  if (seat.busEntityType === BusEntityType.Fridge) {
    return (
      <div className="seat-detail">
        <FridgeIcon />
      </div>
    );
  }
  if (seat.busEntityType === BusEntityType.ToiletLeft) {
    return (
      <div className="seat-detail">
        <ToiletIcon style={{ transform: 'rotateY(180deg)' }} />
      </div>
    );
  }
  if (seat.busEntityType === BusEntityType.ToiletRight) {
    return (
      <div className="seat-detail">
        <ToiletIcon />
      </div>
    );
  }

  return (
    <div className="seat-detail">
      <Popover
        className="seat-container"
        title={<b>{seat.entityName || t('seatModelsPage_SeatInfo')}</b>}
        onVisibleChange={v => toggleDetail(v)}
        trigger="click"
        visible={showDetail}
        content={
          <Form
            layout="vertical"
            initialValues={{
              entityName: seat.entityName,
              baseTicketClassId: seat.baseTicketClassId,
            }}
          >
            <Form.Item label={t('seatModelsPage_TicketClass')} name="baseTicketClassId">
              <Select className="input-value-color" disabled options={ticketClassOptions}></Select>
            </Form.Item>
            <Form.Item label={t('seatModelsPage_SeatName')} name="entityName">
              <Input className="input-value-color" disabled />
            </Form.Item>
          </Form>
        }
      >
        <SeatIcon style={{ fill: color || '#ccc', cursor: 'pointer', height: '70%' }} />
        <div className="seat-number">{seat.entityName}</div>
      </Popover>
    </div>
  );
}
